import { canAccessAdmin, canAccessBilling, isOrgInstructor } from '../services/instructorPortalAccess';

/**
 * Plan & billing is NOT a Settings tab for anyone — it lives in the Admin section
 * (the owner-only Billing sidebar page). Instructors and admins have no billing
 * surface at all; they inherit the org plan.
 */
const ALL_SETTINGS_TABS = [
  { key: 'org', label: 'Organisation' },
  { key: 'profile', label: 'Profile' },
  { key: 'account', label: 'Account' },
  { key: 'register', label: 'Register' },
];

/**
 * Settings tabs visible for the current org role. Instructors don't get the
 * Account tab — it holds org-level payout/bank details they must not manage.
 */
export function getVisibleSettingsTabs(entitlements) {
  if (isOrgInstructor(entitlements)) {
    return ALL_SETTINGS_TABS.filter((tab) => tab.key !== 'account');
  }
  return [...ALL_SETTINGS_TABS];
}

/** Default tab when /settings loads without ?tab=. */
export function getDefaultSettingsTab(entitlements) {
  return canAccessAdmin(entitlements) ? 'profile' : 'org';
}

/**
 * Sanitises the requested ?tab= against the visible tabs so a stale bookmark
 * (e.g. ?tab=plan) can never render a tab the role no longer has.
 */
export function resolveActiveSettingsTab(entitlements, requestedTab) {
  const visible = getVisibleSettingsTabs(entitlements).some((tab) => tab.key === requestedTab);
  return visible ? requestedTab : getDefaultSettingsTab(entitlements);
}

/**
 * Where a ?tab=plan deep link should land: owners on the Billing page, org
 * admins on the read-only Admin → Plan & billing tab, instructors nowhere
 * (null — they fall back to their default Settings tab).
 */
export function planTabRedirectPath(entitlements, tab) {
  if (tab !== 'plan') {
    return null;
  }
  if (canAccessBilling(entitlements)) {
    return '/Portal/Instructor/billing';
  }
  if (canAccessAdmin(entitlements)) {
    return '/Portal/Instructor/admin/billing';
  }
  return null;
}

/** True when a billing manager deep-linking ?tab=plan should land on the Billing page. */
export function shouldRedirectPlanTabToBilling(entitlements, tab) {
  return tab === 'plan' && canAccessBilling(entitlements);
}
